// extracted by mini-css-extract-plugin
module.exports = {"base":"highlight-to-anchor_base__Dg89G","scrolled-to":"highlight-to-anchor_scrolled-to__hknYF","scrolledTo":"highlight-to-anchor_scrolledTo__dKwtr"};